/**
 * Iter-158.13.2.20f.42-kiwi2 — Operation Kiwi visual correction:
 * canonical OnSetFlow wordmark, extracted so the login page and
 * the ProjectHeader masthead share one source of truth.
 *
 * Canonical treatment (established by the login page):
 *   font-display · font-black · leading-none
 *   "OnSet" white · "Flow" neutral-500
 *   exact mixed-case spelling
 *
 * Callers control size via className passthrough — a tall hero
 * usage passes `text-5xl sm:text-6xl`; the persistent masthead
 * passes a header-appropriate `text-xl` or similar.
 */
export default function OnSetFlowWordmark({
    as: Tag = "span",
    className = "",
    testid,
    ...rest
}) {
    return (
        <Tag
            data-testid={testid}
            className={`font-display font-black leading-none ${className}`.trim()}
            {...rest}
        >
            <span className="text-white">OnSet</span>
            <span className="text-neutral-500">Flow</span>
        </Tag>
    );
}
